export default (list, t, listName, extension) => {
  const sheetName = 'Export';
  const fileNameSuffix = ' ' + new Date().toLocaleString() + `.${extension}`;
  const cleanList = list.map(({ __typename, ...rest }) => rest);

  switch (listName) {
    case 'insuranceOfferList': {
      return {
        formattedList: cleanList.map(z => ({
          [t('Offer.List.Field.DocumentNumber')]: z.DocumentNumber,
          [t('Offer.List.Field.DocumentDate')]: z.DocumentDate,
          [t('Offer.List.Field.User')]: z.UserName
        })),
        fileName: [t('NavBar.Offers')] + fileNameSuffix,
        sheetName: sheetName
      };
    }
    case 'renewalPolicies': {
      return {
        formattedList: cleanList.map(z => {
          const element = {
            [t('Offer.PolicyRenewalList.Field.PolicyNumber')]: z.documentNumber,
            [t('Offer.PolicyRenewalList.Field.Period')]: z.renewalPolicyDocument.period,
            [t('Offer.PolicyRenewalList.Field.StartDate')]: z.renewalPolicyDocument.startDate,
            [t('Offer.PolicyRenewalList.Field.FinishDate')]: z.renewalPolicyDocument.finishDate,
            [t('Offer.PolicyRenewalList.Field.AMR')]: z.renewalPolicyDocument.remainingDays,
            [t('Offer.PolicyRenewalList.Field.Amount')]: z.renewalPolicyDocument.amount,
            [t('Offer.PolicyRenewalList.Field.Insurer')]: z.renewalPolicyDocument.insurerName,
            [t('Offer.PolicyRenewalList.Field.CascoInsurer')]: z.renewalPolicyDocument.cascoInsurerName,
            [t('Offer.PolicyRenewalList.Field.Insured')]: z.renewalPolicyDocument.insured.partnerName,
            [t('Offer.PolicyRenewalList.Field.Client')]: z.renewalPolicyDocument.client.partnerName,
            [t('Offer.PolicyRenewalList.Field.UniqueId')]: z.renewalPolicyDocument.client.uniqueID,
            [t('Offer.PolicyRenewalList.Field.ChassisNumber')]: z.renewalPolicyDocument.asset.chassisNumber,
            [t('Offer.PolicyRenewalList.Field.Brand')]: z.renewalPolicyDocument.asset.brand,
            [t('Offer.PolicyRenewalList.Field.Model')]: z.renewalPolicyDocument.asset.model,
            [t('Offer.PolicyRenewalList.Field.CylindricCapacity')]: z.renewalPolicyDocument.asset.cylindricCapacity,
            [t('Offer.PolicyRenewalList.Field.EnginePower')]: z.renewalPolicyDocument.asset.enginePower,
            [t('Offer.PolicyRenewalList.Field.SeatsNumber')]: z.renewalPolicyDocument.asset.seatsNumber,
            [t('Offer.PolicyRenewalList.Field.MaxWeight')]: z.renewalPolicyDocument.asset.maxWeight,
            [t('Offer.PolicyRenewalList.Field.RegistrationNumber')]: z.renewalPolicyDocument.asset.registrationNumber,
            [t('Offer.PolicyRenewalList.Field.ManufacturingYear')]: z.renewalPolicyDocument.asset.manufacturingYear,
            [t('Offer.PolicyRenewalList.Field.ContractNumber')]: z.renewalPolicyDocument.contractNumber,
            [t('Offer.PolicyRenewalList.Field.ContractState')]: z.renewalPolicyDocument.contractState,
            [t('Offer.PolicyRenewalList.Field.ContractFinishDate')]: z.renewalPolicyDocument.contractFinishDate,
            [t(
              'Offer.PolicyRenewalList.Field.Offer'
            )]: `${z.renewalPolicyDocument.documentNumber} (${z.renewalPolicyDocument.documentState})`,
            [t('Offer.PolicyRenewalList.Field.QuotationsDate')]: z.renewalPolicyDocument.quotationsDate,
            [t('Offer.PolicyRenewalList.Field.SentToClientDate')]: z.renewalPolicyDocument.sentToClientDate
          };
          z.renewalPolicyDocument.quotations?.forEach(quotation => {
            element[
              t('Offer.PolicyRenewalList.Field.QuotationTitle', {
                insurerName: quotation.insurerName,
                period: quotation.period
              })
            ] = quotation.insuranceAmount ? `${quotation.insuranceAmount} ${quotation.currencyCode}` : null;
          });
          return element;
        }),
        fileName: [t('NavBar.Policy-Renewal')] + fileNameSuffix,
        sheetName: sheetName
      };
    }
    default: {
      return { formattedList: cleanList, fileName: 'Export' + fileNameSuffix, sheetName: sheetName };
    }
  }
};
